import moment from 'moment';

class ComponentDataService {

    constructor(_, componentRegistryService, securityService, dateTimeService, constants) {
        this._ = _;
        this.componentRegistryService = componentRegistryService;
        this.securityService = securityService;
        this.model = null;
        this.dto = null;
        this.modelMap = null;
        this.formatDate = dateTimeService.formatDate;
        this.convertToDateString = dateTimeService.convertToDateString;
        this.constants = constants
    }

    setDto(dto) {
        this.dto = dto;
    }
    
    getDto(disclosureType) {
        this.model = this.getComponentModel();
 
        let data = {
            type: disclosureType,
            discloserId: this.securityService.getAutheticatedUserId(),
            alternativeOfficerId: this._.get(this.model.alternativeOfficer, "curtinId", null),
            conflictCategory: this._.get(this.model.conflictCategory, "id", null),
            description: this.model.description
        };

        let selectedManagerForConflict = this._.get(this.model.selectedManager, "curtinId", null);

        if (disclosureType === 'Conflict' && selectedManagerForConflict) {
            data.lineManagerId = selectedManagerForConflict;
        }

        let selectedManagerForGift = this._.get(this.model.giftApprovalOfficer, "curtinId", null);
        if (disclosureType === 'Gift' && selectedManagerForGift) {
            data.lineManagerId = selectedManagerForGift;
        }

        if (this.model.executiveManager) {
            data.alternativeOfficerId = this.model.executiveManager;
        }
        
        if (this.model.alternativeOfficer) {
            data.alternativeOfficer = this._.assign({}, this.model.alternativeOfficer);
        } 

        if (this._.get(this.model.closePersonalRelationship, "selectedOption.id", null) === 'External') {
            data.conflictRelationship = [
            {
                curtinId: "",
                preferredName: "",
                firstName : "",
                lastName: "",
                fullName: this.model.closePersonalRelationshipWithName || this.model.closePersonalRelationship.fullName,
                emailAddress: "",
                positionTitle: this.model.closePersonalRelationshipWithPosition || this.model.closePersonalRelationship.position,
                division: this.model.closePersonalRelationshipWithOrganisation || this.model.closePersonalRelationship.division,
                area: "",
                department: ""
            }];
        }

        if (this.model.closePersonalRelationshipWith) {
            data.conflictRelationship = [this._.assign({}, this.model.closePersonalRelationshipWith)];
        }
        
        if (this.model.giftRecipients) {
            data.conflictRelationship = this.model.giftRecipients;
        }

        if (this.model.secondaryEmployment && this.model.secondaryEmployment.selectedOption) {
            data.secondaryEmployment = {
                Type : this.model.secondaryEmployment.selectedOption.id
            };
            if (data.secondaryEmployment.Type === 'Secondary') {
                data.secondaryEmployment.entityName = this.model.secondaryEntityName;
                data.secondaryEmployment.positionHeld = this.model.secondaryPositionHeld;
                data.secondaryEmployment.hoursPerWeek = this.model.secondaryHoursPerWeek;
            } else {
                data.secondaryEmployment.entityName = this.model.privateEntityName;
                data.secondaryEmployment.role = this.model.privateRole;
                data.secondaryEmployment.servicesProvided = this.model.privateServicesProvided;
            }
        }

        if (this.model.foreignInterference) {
            data.foreignInterference = {
                isReceivingAcademicFinancialSupportOverseas: this.model.foreignInterference.question1.questionBool,
                isCurtinWorkCriticalTechnology: this.model.foreignInterference.question2a.questionBool,
                haveCurrentOrPastExternalPositionOrObligation: this.model.foreignInterference.question2b.questionBool,
                haveCurrentExternalPositionOrObligation: this.model.foreignInterference.question2c.questionBool,
                hasForeignAssociation: this.model.foreignInterference.question3.questionBool,
                isEngagedInOtherActivity: this.model.foreignInterference.question4.questionBool,
                foreignAssociationDetailResponses: []
            };

            if (this.model.foreignInterference.question1.questionBool === true) {
                data.foreignInterference.foreignAssociationDetailResponses.push.apply(data.foreignInterference.foreignAssociationDetailResponses, this.model.foreignInterference.question1.questionResponses)
            }

            if (this.model.foreignInterference.question2a.questionBool === true &&
                this.model.foreignInterference.question2b.questionBool === true) {
                data.foreignInterference.foreignAssociationDetailResponses.push.apply(data.foreignInterference.foreignAssociationDetailResponses, this.model.foreignInterference.question2b.questionResponses)

            }

            if (this.model.foreignInterference.question2a.questionBool === false &&
                this.model.foreignInterference.question2c.questionBool === true) {
                data.foreignInterference.foreignAssociationDetailResponses.push.apply(data.foreignInterference.foreignAssociationDetailResponses, this.model.foreignInterference.question2c.questionResponses)
            }

            if (this.model.foreignInterference.question3.questionBool === true) {
                data.foreignInterference.foreignAssociationDetailResponses.push.apply(data.foreignInterference.foreignAssociationDetailResponses, this.model.foreignInterference.question3.questionResponses)
            }

            if (this.model.foreignInterference.question4.questionBool === true) {
                data.foreignInterference.foreignAssociationDetailResponses.push.apply(data.foreignInterference.foreignAssociationDetailResponses, this.model.foreignInterference.question4.questionResponses)
            }
        }

        // Todo: define Enum for conflict type
        if (disclosureType === "Gift") {
            data.giftDetail = {};

            data.giftDetail.DoesAcceptanceCreateConflictOfInterest = this.model.doesAcceptanceCreateConflictOfInterest;
            data.giftDetail.ExceedValue = this.model.exceedValue;
            data.giftDetail.GiftValue = this.model.giftValue;
            data.giftDetail.GifterName = this.model.gifterName;
            data.giftDetail.IsSeniorOfficer = this.model.isSeniorOfficer;
            data.giftDetail.ReceivedFromIndividualOrOrganisation = this.model.receivedFromIndividualOrOrganisation;
            data.giftDetail.TotalValueOfGifts = this.model.totalValueOfGifts;
            data.giftDetail.WasForAGroup = this.model.wasForAGroup;
            data.giftDetail.dateReceived = this.convertToDateString(this.model.dateReceived);
        }

        return data;
    }

    getComponentModel() {
        let model = {};
        this._.map(this.componentRegistryService.getRegistered(), (c) => {
            if (c.getModel()) {
                model = this._.assign({}, model, c.getModel());   
            }
            
        });
        return model;
    }

    setModel(component) {
        if (component.modelName === 'giftApprovalOfficer') {
            component.setModel(this.dto.lineManager);
        }

        if (component.modelName === 'alternativeOfficer') {
            component.setModel(this._.assign({}, this.dto.alternativeOfficer));
        }

        if (this.dto && this.dto.disclosureData) {
            if (component.modelName === 'conflictCategory') {
                component.setModel({ id: this.dto.disclosureData.conflictCategory });
            }

            if (component.modelName === 'description') {
                component.setModel(this.dto.disclosureData.description);
            }

            if (component.modelName === 'selectedManager') {
                component.setModel(this.dto.lineManager);
            }
            
            if (component.modelName === 'executiveManager' && this.dto.disclosureData.alternativeOfficerId) {
                component.setModel(this.dto.disclosureData.alternativeOfficerId);
            }

            if (component.modelName === 'closePersonalRelationship') {
                component.setModel({
                    selectedOptionId: this.dto.disclosureData.conflictRelationship[0].curtinId ? "Curtin" : "External",
                    fullName: this.dto.disclosureData.conflictRelationship[0].fullName,
                    position: this.dto.disclosureData.conflictRelationship[0].positionTitle,
                    division: this.dto.disclosureData.conflictRelationship[0].division
                });
            }

            if (component.modelName === 'closePersonalRelationshipWithName') {
                component.setModel(this.dto.disclosureData.conflictRelationship[0].fullName);
            }

            if (component.modelName === 'closePersonalRelationshipWithPosition') {
                component.setModel(this.dto.disclosureData.conflictRelationship[0].positionTitle);
            }

            if (component.modelName === 'closePersonalRelationshipWithOrganisation') {
                component.setModel(this.dto.disclosureData.conflictRelationship[0].division);
            }
            
            if (component.modelName === 'closePersonalRelationshipWith') {
                component.setModel(this._.assign({}, this.dto.disclosureData.conflictRelationship && this.dto.disclosureData.conflictRelationship[0].curtinId ? this.dto.disclosureData.conflictRelationship[0] : null));
            }

            if (component.modelName === 'giftRecipients') {
                component.setModel(this.dto.disclosureData.conflictRelationship);
            }

            if (component.modelName === 'secondaryEmployment' && this.dto.disclosureData.secondaryEmployment) {
                component.setModel({
                    selectedOption: this.dto.employmentOptions.filter((option) => option.id === this.dto.disclosureData.secondaryEmployment.type)[0],
                });
            }

            // New ForeignAssociationType values are defined under: Curtin.COI.API.Enums.ForeignAssociationType
            if (component.modelName === 'foreignInterference' && this.dto.disclosureData.foreignInterference) {
                component.setModel({
                    question1: {
                        questionBool: this.dto.disclosureData.foreignInterference.isReceivingAcademicFinancialSupportOverseas,
                        questionResponses: this.filterForeignInterferenceIfNotNull(this.dto.disclosureData, this.constants.ForeignInterference.questions.question1.foreignAssociationType)
                    },
                    question2a: {
                        questionBool: this.dto.disclosureData.foreignInterference.isCurtinWorkCriticalTechnology,
                    },
                    question2b: {
                        questionBool: this.dto.disclosureData.foreignInterference.haveCurrentOrPastExternalPositionOrObligation,
                        questionResponses: this.filterForeignInterferenceIfNotNull(this.dto.disclosureData, this.constants.ForeignInterference.questions.question2b.foreignAssociationType)
                    },
                    question2c: {
                        questionBool: this.dto.disclosureData.foreignInterference.haveCurrentExternalPositionOrObligation,
                        questionResponses: this.filterForeignInterferenceIfNotNull(this.dto.disclosureData, this.constants.ForeignInterference.questions.question2c.foreignAssociationType)
                    },
                    question3: {
                        questionBool: this.dto.disclosureData.foreignInterference.hasForeignAssociation,
                        questionResponses: this.filterForeignInterferenceIfNotNull(this.dto.disclosureData, this.constants.ForeignInterference.questions.question3.foreignAssociationType)
                    },
                    question4: {
                        questionBool: this.dto.disclosureData.foreignInterference.isEngagedInOtherActivity,
                        questionResponses: this.filterForeignInterferenceIfNotNull(this.dto.disclosureData, this.constants.ForeignInterference.questions.question4.foreignAssociationType)
                    }
                });
            }

            if (component.modelName === 'managementStrategy' && this.dto.disclosureData.managementStrategy) {
                component.setModel({
                    selectedOption: this.dto.managementStrategies.filter((option) => option.id === this.dto.disclosureData.managementStrategy.type)[0],
                });
            }

            if (this.dto.disclosureData.secondaryEmployment && this.dto.disclosureData.secondaryEmployment.type === "Secondary") {

                if (component.modelName === 'secondaryEntityName') {
                    component.setModel(this.dto.disclosureData.secondaryEmployment.entityName);
                }

                if (component.modelName === 'secondaryPositionHeld') {
                    component.setModel(this.dto.disclosureData.secondaryEmployment.positionHeld);
                }

                if (component.modelName === 'secondaryHoursPerWeek') {
                    component.setModel(this.dto.disclosureData.secondaryEmployment.hoursPerWeek);
                }
            } 
            
            if (this.dto.disclosureData.secondaryEmployment && this.dto.disclosureData.secondaryEmployment.type === "Private") {

                if (component.modelName === 'privateEntityName') {
                    component.setModel(this.dto.disclosureData.secondaryEmployment.entityName);
                }

                if (component.modelName === 'privateRole') {
                    component.setModel(this.dto.disclosureData.secondaryEmployment.role);
                }

                if (component.modelName === 'privateServicesProvided') {
                    component.setModel(this.dto.disclosureData.secondaryEmployment.servicesProvided);
                }
            }

            if (this.dto.disclosureData.giftDetail) {
                if (component.modelName === 'doesAcceptanceCreateConflictOfInterest') {
                    component.setModel(this.dto.disclosureData.giftDetail.doesAcceptanceCreateConflictOfInterest);             
                }
                if (component.modelName === 'exceedValue') {
                    component.setModel(this.dto.disclosureData.giftDetail.exceedValue);
                }
                if (component.modelName === 'giftValue') {
                    component.setModel(this.dto.disclosureData.giftDetail.giftValue ? this.dto.disclosureData.giftDetail.giftValue.toString() : null);
                }
                if (component.modelName === 'dateReceived') {                   
                    component.setModel(this.dto.disclosureData.giftDetail.dateReceived);      
                }
                if (component.modelName === 'gifterName') {
                    component.setModel(this.dto.disclosureData.giftDetail.gifterName);
                    if (component.model) {
                        component.vm.isValid = component.validate();
                    }
                }
                if (component.modelName === 'isSeniorOfficer') {
                    component.setModel(this.dto.disclosureData.giftDetail.isSeniorOfficer);
                }
                if (component.modelName === 'receivedFromIndividualOrOrganisation') {
                    component.setModel(this.dto.disclosureData.giftDetail.receivedFromIndividualOrOrganisation);
                }
                if (component.modelName === 'totalValueOfGifts') {
                    component.setModel(this.dto.disclosureData.giftDetail.totalValueOfGifts ? this.dto.disclosureData.giftDetail.totalValueOfGifts.toString() : null);
                }
                if (component.modelName === 'wasForAGroup') {
                    component.setModel(this.dto.disclosureData.giftDetail.wasForAGroup);
                }                
            }
            
            if (this.dto.disclosureData.managementStrategy) {
                if (component.modelName === 'managementStrategyText') {
                    component.setModel({
                        selectedOption: this._.find(this.dto.managementStrategies, (option) => option.id === this.dto.disclosureData.managementStrategy.type)
                    });
                }
                if (component.modelName === 'assessorComments') {
                    component.setModel(this.dto.disclosureData.managementStrategy.comments);             
                }
            }

            if (component.modelName === 'isuNotes') {
                component.setModel(this.dto.disclosureData.isuReviewNotes);
            }

            if (component.modelName === 'deactivationNotes') {
                component.setModel(this.dto.disclosureData.deactivationNotes);
            }

        }
    }

    filterForeignInterferenceIfNotNull(disclosureDataDto, foreignAssociationTypeName) {
        let arrayToFilter = disclosureDataDto.foreignInterference.foreignAssociationDetailResponses;

        if (arrayToFilter != null) {
            let filteredArray = arrayToFilter.filter(dr => dr.foreignAssociationType === foreignAssociationTypeName);
            if (filteredArray.length > 0) {
                return filteredArray;
            }
        }
        else {
            return [{
                'countryName': null,
                'organisationName': null,
                'associationSummary': null,
                'foreignAssociationType': foreignAssociationTypeName
            }];
        }
    }
    
    updateModel(component) {
        if (component.modelName === 'conflictCategory' && this.dto.disclosureData) {
            this.dto.disclosureData = this._.omit(this.dto.disclosureData, ['conflictCategory']);
        }
        
        if (component.modelName === 'description' && this.dto.disclosureData) {
            this.dto.disclosureData = this._.omit(this.dto.disclosureData, ['description']);
        }
        
        if (component.modelName === 'closePersonalRelationshipWith' && this.dto.disclosureData) {
            this.dto.disclosureData = this._.omit(this.dto.disclosureData, ['conflictRelationship']);
        }
        
        if (component.modelName === 'secondaryEmploymentDetails' && this.dto.disclosureData) {
            this.dto.disclosureData = this._.omit(this.dto.disclosureData, ['secondaryEmployment']);
        }

        if (component.modelName === 'foreignInterference' && this.dto.disclosureData) {
            this.dto.disclosureData = this._.omit(this.dto.disclosureData, ['foreignInterference']);
        }
    }

    static componentDataServiceFactory(_, componentRegistryService, securityService, dateTimeService, constants) {
        return new ComponentDataService(_, componentRegistryService, securityService, dateTimeService, constants);
    }
}

ComponentDataService.componentDataServiceFactory.$inject = ['_', 'componentRegistryService', 'securityService', 'dateTimeService', 'constants'];

export default ComponentDataService;


// WEBPACK FOOTER //
// ./app/services/component-data.service.js